<script>
  /**
   * 複数のボタンからの選択と自由記入ができるテキスト入力欄
   */
  import TextInput from './TextInput.svelte'
  import RadioButtons from '../RadioButtons.svelte'

  export let id = undefined
  export let name
  export let type = 'text'
  export let label = ''
  export let inputAttributes = null // 編集用inputタグに付けたい属性をセットする
  export let value = undefined
  export let options = []
  export let columnSize = null

  const selectHandler = selectedValue => (value = selectedValue)
</script>

<TextInput
  id={`${id || name}ComboInput`}
  {name}
  {type}
  {label}
  {inputAttributes}
  bind:value
>
  <RadioButtons {name} {options} {columnSize} {selectHandler} {value} />
</TextInput>
